import { render, staticRenderFns } from "./NavbarHeader.vue?vue&type=template&id=63ab24e7&"
import script from "./NavbarHeader.vue?vue&type=script&lang=js&"
export * from "./NavbarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports